
export function initTooltips() {
	const Tooltip = window.Tooltip || null;

	if (Tooltip) {
		const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl)
		});
	}
}
